import * as React from 'react';
import * as styles from './styles.css';
import cn from 'clsx';
import { useDeviceType, Button } from '@cian/ui-kit';

import { ValuationNotFound } from '../ValuationNotFound';
import { ValuationReady } from '../ValuationReady';

export interface IValuationFiltersSubmitLayoutProps {
  containerRef: React.RefObject<HTMLDivElement>;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  onEstimationReadyClick(): void;
  isFetching?: boolean;
  className?: string;
  buttonText: string;
  isNotFound?: boolean;
  isEstimationReady?: boolean;
}

export const ValuationFiltersSubmitLayout: React.FC<IValuationFiltersSubmitLayoutProps> = props => {
  const { containerRef, isFetching, onClick, buttonText, isNotFound, isEstimationReady, onEstimationReadyClick } =
    props;
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div
      ref={containerRef}
      className={cn(styles['container'], styles['shadow'], !isDesktop && styles['container-not-desktop'])}
    >
      {isNotFound && (
        <div className={styles['message']}>
          <ValuationNotFound />
        </div>
      )}
      {isEstimationReady && (
        <div className={styles['message']}>
          <ValuationReady isDesktop={isDesktop} onClick={onEstimationReadyClick} />
        </div>
      )}
      <div className={styles['action']}>
        <Button
          data-testid="next-button"
          onClick={onClick}
          theme="fill_primary"
          size="M"
          loading={Boolean(isFetching)}
          disabled={isNotFound}
          fullWidth
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

ValuationFiltersSubmitLayout.displayName = 'ValuationFiltersSubmitLayout';
